import React, { Component } from 'react'
import { I18n } from 'react-redux-i18n'
import { Button, Dropzone } from '../Form'
import { FormGroup, Col, Alert } from 'reactstrap'
import FilePreview from './FilePreview'
import { MIN_FILE_SIZE_DEFAULT } from 'constants/filesMaxSize'
import ModalPlan from 'components/ModalPlan'

export default class UploadFiles extends Component {
  constructor(props) {
    super(props)

    this.state = {
      files: [],
      errors: {},
      showPlanModal: false
    }

    this.onUploadFiles = this.onUploadFiles.bind(this)
    this.onRemoveFile = this.onRemoveFile.bind(this)
    this.onDrop = this.onDrop.bind(this)
    this.toggleModalPlan = this.toggleModalPlan.bind(this)
  }

  toggleModalPlan() {
    this.setState({ showPlanModal: !this.state.showPlanModal })
  }

  onUploadFiles() {
    const files = [].concat(this.state.files)

    this.props
      .uploadFiles(files)
      .then((data) => this.setState({ files: data || [] }, this.props.cancel))
      .catch((error) => {
        this.setState({ errors: { error } })
      })
  }

  onRemoveFile(key) {
    const files = [].concat(this.state.files)
    files.splice(key, 1)
    this.setState({ files })
  }

  onDrop(dropFiles) {
    this.props.removeOnDrop && this.props.onRemoveUploadedFile()
    this.setState((prevState) => ({
      files: this.props.multiple ? [].concat(prevState.files, dropFiles) : dropFiles,
    }))
    this.props.onDrop && this.props.onDrop(this.state.files)
  }

  render() {
    const {
      state: { files, errors: stateErrors },
      props: {
        filesUploaded = [],
        onRemoveUploadedFile,
        uploading,
        multiple = true,
        cancelButton = true,
        acceptTypes = '',
        maxSize,
        messageErrorSize,
        messageErrorDimensions,
        labelSize,
        dimensions
      }
    } = this

    return (
      <div className='upload-files-dropzone' hidden={this.props.hidden}>
        <FormGroup>
          <Dropzone
            imgTotalDimensions10000px
            accept={acceptTypes}
            handleDrop={this.onDrop}
            multiple={multiple}
            maxSize={maxSize || MIN_FILE_SIZE_DEFAULT}
            dimensions={dimensions}
            messageErrorSize={messageErrorSize || I18n.t('error_default_file_too_big')}
            messageErrorDimensions={messageErrorDimensions}
            labelSize={labelSize}
          />
        </FormGroup>
        {(filesUploaded.length > 0 || files.length > 0) && (
          <FormGroup>
            <div className='d-flex align-items-start wrapper-file-preview'>
              {filesUploaded.map((file, key) => (
                <FilePreview
                  name={file.name}
                  key={(file.url || file.urlLong) + key}
                  id={key}
                  url={file.urlLong || file.url}
                  thumb={file.thumb}
                  shortUrl={file.url || file.urlLong}
                  type={file.type}
                  mimeType={file.mimeType}
                  mimeSubtype={file.mimeSubtype}
                  extension={file.extension}
                  onRemoveFile={onRemoveUploadedFile}
                  withVirus={file.withVirus}
                />
              ))}
              {files.map((file, key) => (
                <FilePreview
                  name={file.name}
                  key={(file.name || file.path || '') + key}
                  id={key}
                  url={file.preview || file.urlLong || file.url}
                  thumb={file.thumb}
                  shortUrl={file.url || file.urlLong}
                  type={file.type || file?.file?.type}
                  mimeType={file.mimeType}
                  mimeSubtype={file.mimeSubtype}
                  extension={file.extension}
                  onRemoveFile={this.onRemoveFile}
                  withVirus={file.withVirus}
                />
              ))}
            </div>
          </FormGroup>
        )}

        {Object.keys(stateErrors).length > 0 && (
          <FormGroup row>
            {Object.values(stateErrors).map((error, i) => (
              <Col sm={12} key={i}>
                <Alert color='danger'>{I18n.t(`dashboard_errors_${error}`) || I18n.t(error)}</Alert>
              </Col>
            ))}
          </FormGroup>
        )}

        {!this.props.removeButtons &&
          <div className='upload-files-dropzone__buttons-container'>
            {cancelButton && (
              <Button secondary onClick={this.props.cancel}>
                {I18n.t('dashboard_cancel')}
              </Button>
            )}
            <Button primary disabled={!files.length} onClick={this.onUploadFiles} isSubmitting={uploading}>
              {I18n.t('dashboard_upload')}
            </Button>
          </div>
        }
        <ModalPlan
          isOpen={this.state.showPlanModal}
          toggle={this.toggleModalPlan}
          message={I18n.t('modal_plan_description_media')}
        />
      </div>
    )
  }
}
